export default __webpack_public_path__ + "static/media/iconUploadFile.8dc8fe03.svg";